import React from 'react';
// ✅ Import getFontSize
import { getRadius, getFlexAlignment, getHeight, getFontSize } from '../utils/cssVariableMapper';

const SubmitButton = ({ config, onClick }) => {
  const alignClass = getFlexAlignment(config?.align || 'left');
  const radiusClass = getRadius(config?.radius || 'md');
  const heightClass = getHeight(config?.height || 'md');
  
  // ✅ NEW: Apply dynamic font size
  const fontSizeClass = getFontSize(config?.fontSize || 'md'); 

  const widthClass = config?.width === 'full' ? 'w-full' : 'w-auto px-8';
  
  return (
    <div className={`flex ${alignClass} w-full`}>
      <button
        onClick={onClick}
        className={`
            ${widthClass} ${heightClass} ${fontSizeClass} 
            font-semibold transition-all 
            hover:opacity-90 shadow-sm hover:shadow-md 
            ${radiusClass} active:scale-95 
            flex items-center justify-center
        `}
        style={{ 
            backgroundColor: config?.background || '#0B1C2D', 
            color: config?.textColor || '#ffffff' 
        }}
      >
        {config?.text || "Submit"}
      </button>
    </div>
  );
};

export default SubmitButton;